
/**
 * 조회 시작 날짜 (ISO 8601 형식, 선택 사항)
 */
export type StartDateParamParameter = string;
